package one.healthium.onboarding.ui.screens

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import one.healthium.onboarding.domain.configs.CongratsV2ScreenConfig
import one.healthium.onboarding.ui.UserDataProvider
import one.healthium.onboarding.ui.UserProfileUiModel
import one.healthium.onboarding.ui.bindPlaceholderValues
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.common.utils.toTextAlign
import one.healthium.ui.components.CtaButton
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme

interface CongratsV2EventDelegate {
    fun onNextClicked()
}

@Composable
internal fun CongratsV2Screen(
    eventDelegate: CongratsV2EventDelegate,
    screenConfig: CongratsV2ScreenConfig,
) {
    UserDataProvider { userState, _ ->
        CongratsScreenContent(
            screenConfig = screenConfig,
            userState = userState,
            onNextClicked = eventDelegate::onNextClicked,
        )
    }
}

@Composable
private fun CongratsScreenContent(
    modifier: Modifier = Modifier,
    screenConfig: CongratsV2ScreenConfig,
    userState: UserProfileUiModel,
    onNextClicked: () -> Unit,
) {
    Column(
        modifier = modifier
            .fillMaxSize()
            .gradientBackground(
                backgroundGradient = screenConfig.backgroundGradient,
                fallbackContainerColor = AppTheme.colors.windowBackground,
            )
            .statusBarsPadding()
            .navigationBarsPadding(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Spacer(Modifier.height(24.dp))

        val textAlign = screenConfig.textAlign.toTextAlign() ?: TextAlign.Start

        AppText(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            text = screenConfig.title?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.titleSemiBold,
            color = AppTheme.colors.textInverted100,
            textAlign = textAlign,
        )
        Spacer(Modifier.height(16.dp))
        AppText(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp),
            text = screenConfig.subtitle?.bindPlaceholderValues(userState),
            style = AppTheme.textStyles.subTitle,
            color = AppTheme.colors.textInverted100,
            textAlign = textAlign,
        )
        Spacer(Modifier.height(24.dp))
        Spacer(Modifier.weight(1f))
        CtaButton(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 38.dp),
            text = screenConfig.ctaTitle,
            onClick = onNextClicked,
        )
        Spacer(Modifier.height(24.dp))
    }
}

internal fun Modifier.gradientBackground(
    backgroundGradient: List<one.healthium.domain.common.Color>?,
    fallbackContainerColor: Color,
) = composed {
    if (backgroundGradient?.isNotEmpty() == true) {
        Modifier.background(Brush.linearGradient(backgroundGradient.mapNotNull { it.toColor() }))
    } else {
        Modifier.background(fallbackContainerColor)
    }
}